export default {
  user: undefined,
  showModel: false
}
